var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-page page-corps"},[(!_vm.isLoading)?[_c('AppPageHeader',{attrs:{"page-title":"Корпорации"}}),_c('div',{staticClass:"app-page__content"},[_c('div',{staticClass:"app-layout"},[_c('CorpsIntro')],1)])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }